import { Room } from '../entities/room';

export interface CreateRoomDTO {
  projectId: string;
  name: string;
  description?: string;
}

export interface UpdateRoomDTO {
  name?: string;
  description?: string | null;
}

export interface RoomDTO {
  id: string;
  userId: string;
  projectId: string;
  name: string;
  description: string | null;
  lastMessageAt: Date | null;
  createdAt: Date;
  updatedAt: Date;
}

export class RoomMapper {
  static toDTO(room: Room): RoomDTO {
    return {
      id: room.id,
      userId: room.user_id,
      projectId: room.project_id,
      name: room.name,
      description: room.description,
      lastMessageAt: room.last_message_at,
      createdAt: room.created_at,
      updatedAt: room.updated_at
    };
  }
}